import { LoadingIcon } from '@assets/icons';
import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { Box, Container } from '@mui/material';
import { useCurrentWorkspace } from '@navigation/WorkspaceContext';
import { navigate } from 'gatsby';
import { useEffect } from 'react';
import { WorkspacesAreaWrapper } from './WorkspacesAreaWrapper';
import { WorkspaceRecentDatasets } from './WorkspacesRecentDatasets';
import { WorkspaceRecentGraphs } from './WorkspacesRecentGraphs';
import { WorkspaceRecentJobs } from './WorkspacesRecentJobs';
import { WorkspaceRecentUsage } from './WorkspacesRecentUsage';

export const WorkspaceLandingPage = () => {
  const { workspace, startPolling, stopPolling } = useCurrentWorkspace();

  useEffect(() => {
    if (workspace?.status !== 'ready') {
      startPolling(1000);
    } else {
      stopPolling();
    }
    return () => stopPolling();
  }, [workspace?.status, startPolling, stopPolling]);

  if (workspace?.status !== 'ready') {
    const message = `Syncing workspace${
      workspace?.status === 'syncing-databases'
        ? ' databases'
        : workspace?.status === 'syncing-objects'
          ? ' objects'
          : ''
    }`;
    return (
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LoadingIcon size={16} />
        <Typography variant="subtitle1">{message}</Typography>
        <Button onClick={() => navigate('/')}>Return to landing page</Button>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateAreas: '"graphs jobs datasets" "graphs limits datasets"',
        gridTemplateColumns: '2fr 3fr minmax(475px, 2fr)',
        gridTemplateRows: '1fr 1fr',
        rowGap: 10,
        columnGap: 6,
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        pb: 4,
      }}
    >
      <WorkspacesAreaWrapper title="Recent graphs" gridArea="graphs">
        <WorkspaceRecentGraphs workspaceId={workspace?.workspaceId} />
      </WorkspacesAreaWrapper>
      <WorkspacesAreaWrapper title="Recent jobs" gridArea="jobs">
        <WorkspaceRecentJobs workspaceId={workspace?.workspaceId} />
      </WorkspacesAreaWrapper>
      <WorkspacesAreaWrapper title="Workspace Limits" gridArea="limits">
        <WorkspaceRecentUsage workspaceId={workspace?.workspaceId} />
      </WorkspacesAreaWrapper>
      <WorkspacesAreaWrapper title="Recent datasets" gridArea="datasets">
        <WorkspaceRecentDatasets workspaceId={workspace?.workspaceId} />
      </WorkspacesAreaWrapper>
    </Box>
  );
};
